import {
  MFAChannel,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';
import {useLocation} from 'react-router-dom';
import {redirectWithForwardUrl} from 'utils/utils';

import ConnectedCodeVerification from 'containers/CodeVerification';
import {useGetForwardUrl} from 'hooks/useGetFowardUrl';

export default function SendCodeSuccess() {
  const location = useLocation();
  const channel: MFAChannel | undefined = location?.state?.channel;
  const contactInfoValue: string | undefined =
    location?.state?.contactInfoValue;

  const selectedChannel = useWidgetState(
    Selectors.selectedChannelSelector,
  ) as MFAChannel;
  const forwardUrl = useGetForwardUrl();

  const channelParam = channel ?? selectedChannel;
  if (!channelParam || !contactInfoValue) {
    redirectWithForwardUrl(forwardUrl);
    return null;
  }

  return (
    <ConnectedCodeVerification
      channel={channelParam}
      contactInfoValue={contactInfoValue}
    />
  );
}
